
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { ReportTemplate } from '@/types/reportTypes';

interface TemplateListProps {
  templates: ReportTemplate[];
  onSelectTemplate: (template: ReportTemplate) => void;
}

export const TemplateList = ({ templates, onSelectTemplate }: TemplateListProps) => {
  if (templates.length === 0) {
    return <p className="text-sm text-muted-foreground">No templates available in this filter.</p>;
  }

  return (
    <div className="space-y-2">
      {templates.map(template => (
        <Card 
          key={template.id} 
          className="cursor-pointer hover:bg-accent transition-colors"
          onClick={() => onSelectTemplate(template)}
        >
          <CardContent className="p-3">
            <div className="text-sm font-medium">{template.name}</div>
            <div className="text-xs text-muted-foreground">{template.description}</div>
            <div className="text-xs mt-1 text-primary">{template.category}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
